import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  IconButton,
  Menu,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Badge,
} from '@material-ui/core'
import Button from 'components/theme/Button'
import { Sort } from '@material-ui/icons'
import { Filter } from 'mdi-material-ui'
import DateTimePicker from 'components/theme/DateTimePicker'
import { handleSearchOptionsChange, clearFilters } from 'actions/inbox'
import { isEqual } from 'lodash'

const Date = connect(
  (state, { property }) => ({
    value: state.inbox.conversationSearch[property],
  }),
  (dispatch) => bindActionCreators({ handleSearchOptionsChange }, dispatch),
)(({ property, value, handleSearchOptionsChange }) => (
  <DateTimePicker
    value={value}
    handleChange={(value) => handleSearchOptionsChange(property, value)}
    title={`${property}:`}
    fontSizeSmall
    noMin
    noHelperText
  />
))

const Check = connect(
  (state, { property }) => ({
    value: state.inbox.conversationSearch[property.value],
  }),
  (dispatch) => bindActionCreators({ handleSearchOptionsChange }, dispatch),
)(({ property, value, handleSearchOptionsChange }) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={value}
        onChange={(e) =>
          handleSearchOptionsChange(property.value, e.target.checked)
        }
        value={property.value}
      />
    }
    label={property.label}
  />
))

export default connect(
  state => ({
    filtered: !isEqual(state.inbox.conversationSearch, {
      From: null,
      To: null,
      sms: true,
      email: true,
      call: true,
      formsub: true,
      search: '',
    }),
  }),
  dispatch => bindActionCreators({ clearFilters }, dispatch),
)(
  withStyles(theme => ({
    sort: {
      position: 'absolute',
      top: 12,
      right: 8,
    },
    searchOptionsButton: {
      color: '#c2c2c2',
      padding: 5,
    },
    icon: {
      width: 40,
      height: 40,
    },
    paper: {
      borderRadius: 18,
      border: '1px solid #c3c3c3',
      // padding: 12,
    },
    badge: {
      top: 8,
      right: 8,
      color: '#fff',
      backgroundColor: '#014c94',
      width: 25,
      height: 25,
      borderRadius: '50%',
    },
  }))(
    class SearchOptionsMenuComponent extends Component {
      state = {
        anchorEl: null,
      }

      handleClick = event => {
        this.setState({ anchorEl: event.currentTarget })
      }

      handleClose = () => {
        this.setState({ anchorEl: null })
      }

      render() {
        const { anchorEl } = this.state
        const { classes, filtered } = this.props

        const iconButton = (
          <IconButton
            aria-owns={anchorEl ? 'inbox-sort-options-menu' : undefined}
            aria-haspopup="true"
            onClick={this.handleClick}
            className={classes.searchOptionsButton}
          >
            <Sort className={classes.icon} />
          </IconButton>
        )

        return (
          <div className={classes.sort}>
            <Tooltip title="Search options">
              {filtered ? (
                <Badge
                  classes={{ badge: classes.badge }}
                  badgeContent={<Filter />}
                >
                  {iconButton}
                </Badge>
              ) : (
                iconButton
              )}
            </Tooltip>
            <Menu
              id="inbox-sort-options-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
              classes={{ paper: classes.paper }}
            >
              <div style={{ padding: 12 }}>
                <div style={{ marginBottom: 5 }}>
                  <Date property="From" />
                </div>
                <div>
                  <Date property="To" />
                </div>
              </div>
              <Divider />
              <div style={{ padding: 12 }}>
                <FormGroup>
                  {[
                    { label: 'Text messages', value: 'sms' },
                    { label: 'Email', value: 'email' },
                    { label: 'Phone Calls', value: 'call' },
                    { label: 'Form submissions', value: 'formsub' },
                  ].map(property => (
                    <Check
                      key={`searchOptionsMenuCheck${property.value}`}
                      property={property}
                    />
                  ))}
                </FormGroup>
              </div>
              <div style={{ padding: 12, textAlign: 'center' }}>
                <Button
                  onClick={() => this.props.clearFilters()}
                  color="secondary"
                  variant="contained"
                >
                  Clear filters
                </Button>
              </div>
            </Menu>
          </div>
        )
      }
    },
  ),
)
